import React, { useEffect, useState } from 'react';

import { Switch, Route, useHistory, useLocation } from 'react-router-dom';
import Home from './pages/home/Home';
import Error from './pages/Error';

import './App.css';
// import Navbar from './component/navbar/NavBar';
import NavBar from './component/navbar/NavBar';
import LoginU from './pages/auth/LoginU';
import Register from './pages/auth/Register';
import Forget from './pages/auth/Forget';
import UActivate from './pages/auth/UActivate';
import UReset from './pages/auth/UReset';
import ProtectedRoute from './component/protected/ProtectedRoute';
import Footer from './component/footer/Footer';
import SelfService from './pages/self_service/SelfService';
import Integrations from './pages/integrations/Integrations';
import Gallery from './pages/gallery/Gallery';
import Dashboard from './pages/dashboard/Dashboard';
import PrivacyPolicy from './pages/policy/PrivacyPolicy';
import DataPolicy from './pages/policy/DataPolicy';
import Sessions from './pages/sessions/Sessions';
import ASetting from './pages/setting/ASetting';
import PasswordUpdate from './pages/setting/PasswordUpdate';
import UploadCsv from './pages/uploadcsv/UploadCsv';
import axios from 'axios';
import { apilink } from './data/fdata';
import Cookies from 'js-cookie';
import UnAuth from './component/unauth/UnAuth';

const App = () => {
  const his = useHistory();
  const loc = useLocation();
  const [loginstaus, setLoginStatus] = useState(false);
  // console.log(loc);
  const hecord_tokon = Cookies.get('_hecord_access_user_tokon_');
  const [userDetails, setUserDetails] = useState([]);
  useEffect(async () => {
    const res = await axios.get(`${apilink}/api/user/getUserInfor`, {
      headers: {
        Authorization: hecord_tokon,
      },
    });
    // console.log(res.data);
    if (res.data.success) {
      setUserDetails(res.data.userAccount);
      setLoginStatus(true);
    } else {
      if (res.data.msg == 'Invalid Authentication.') {
        // his.push('/login');
        Cookies.remove('_hecord_access_user_tokon_');
        localStorage.removeItem('_hecord_access_user_login');
        console.clear();
        // if (loc.pathname != '/upload_csv' || loc.pathname != '/reset-password/')
        //   his.push('/login');
      } else {
        console.log(res.data.msg);
      }
    }
  }, []);

  return (
    <>
      <NavBar userDetails={userDetails} loginstaus={loginstaus} />
      <Switch>
        {/* after login  */}
        <ProtectedRoute exact path="/home">
          <Home userDetails={userDetails} />
        </ProtectedRoute>
        <ProtectedRoute exact path="/self_service" component={SelfService} />
        <ProtectedRoute exact path="/integrations" component={Integrations} />
        <ProtectedRoute exact path="/gallery" component={Gallery} />
        <ProtectedRoute exact path="/dashboard" component={Dashboard} />
        <ProtectedRoute
          exact
          path="/privacy_policy"
          component={PrivacyPolicy}
        />
        <ProtectedRoute exact path="/data_policy" component={DataPolicy} />
        <ProtectedRoute exact path="/sessions" component={Sessions} />
        <ProtectedRoute exact path="/account/setting" component={ASetting} />
        <ProtectedRoute
          exact
          path="/password/update"
          component={PasswordUpdate}
        />

        {/* // without login */}
        <Route exact path="/register" component={Register} />
        <Route exact path="/login" component={LoginU} />
        <Route exact path="/password/forget" component={Forget} />
        <Route exact path="/user/activate/:activetoken" component={UActivate} />
        <Route exact path="/reset-password/:accesstoken" component={UReset} />
        <Route exact path="/upload_csv" component={UploadCsv} />
        <Route exact path="/" component={UnAuth} />

        <Route component={Error} />
      </Switch>
      <Footer />
    </>
  );
};

export default App;
